import React from 'react';
import { Link } from 'react-router-dom';
import Header from "../layout/Header";
import Footer from '../layout/Footer';
import Toolbar from '../navigation/Toobar';
import Chat from '../components/common/Chat';
import useSEO from '../hooks/useSEO';
import { buildBreadcrumbJsonLd, getSiteBrand } from '../utils/seo';

const CONTACT_BREADCRUMBS = [
  { name: 'Home', path: '/' },
  { name: 'Contact Us', path: '/contact-us' },
];

function ContactUs({ globalData }) {
  const brandName = globalData?.general?.site_title || getSiteBrand();

  useSEO({
    title: 'Contact Us – 24/7 Customer Support',
    description: `Need help with ${brandName}? Reach our support team through live chat, WhatsApp or the official social channels for deposits, withdrawals, bonuses and account questions.`,
    keywords: `customer support bangladesh, betting site help, deposit problem, withdrawal pending, live chat support, ${brandName} contact`,
    path: '/contact-us',
    brand: brandName,
    jsonLd: [buildBreadcrumbJsonLd(CONTACT_BREADCRUMBS)],
  });

  return (
    <div className="v-application--wrap">
      <div>
        <div className="row no-gutters">
          <Header />
        </div>

        <div className="body">
          <div className="page-container v-card v-sheet theme--dark">
            <div className="row">
              <div className="col col-12">
                <div className="pa-4">
                  <nav className="seo-breadcrumb" aria-label="Breadcrumb">
                    <Link to="/">Home</Link> <span aria-hidden="true">›</span>{' '}
                    <span aria-current="page">Contact Us</span>
                  </nav>

                  <h1 className="seo-h1">Contact {brandName} customer support</h1>
                  <div className="mt-3">
                    <p className="seo-text">
                      Need help with {brandName}? Our support team assists with account access,
                      deposits and withdrawals, promotions, verification and general
                      troubleshooting — day or night.
                    </p>

                    <h2 className="seo-h2">Best ways to reach us</h2>
                    <div className="mt-2">
                      <ul className="mb-0">
                        <li>Use the in-app chat (recommended for the fastest reply).</li>
                        <li>Use the official social channels linked in the footer.</li>
                        <li>If WhatsApp is available, message us through the footer icon.</li>
                      </ul>
                    </div>

                    <h2 className="seo-h2">To resolve your issue faster</h2>
                    <div className="mt-2">
                      <p className="seo-text">When contacting support, please include:</p>
                      <ul className="mb-0">
                        <li>Your username (never your password).</li>
                        <li>Transaction ID and amount, if the issue is payment related.</li>
                        <li>A screenshot or screen recording when possible.</li>
                        <li>The time and date of the issue, plus the device and browser used.</li>
                      </ul>
                    </div>

                    <h2 className="seo-h2">Security note</h2>
                    <div className="mt-2">
                      <p className="seo-text">
                        For your safety, only trust contact methods listed inside the platform,
                        especially the footer icons and the in-app chat. We will never ask for your
                        password, OTP or payment PIN.
                      </p>
                    </div>

                    <h2 className="seo-h2">Helpful before you write</h2>
                    <p className="seo-text">
                      Many questions are already answered in our{' '}
                      <Link to="/faq">FAQ</Link>, including deposit and withdrawal times, turnover
                      rules and password help. Bonus conditions are listed on the{' '}
                      <Link to="/promotion">promotions page</Link>, and the rules of the platform
                      are in the <Link to="/terms-and-conditions">terms and conditions</Link>.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <Footer sociallink={globalData?.socialLinks || {}} />
          </div>

          <Toolbar />
          <Chat />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
